import React, { useState } from 'react';
import SVGInline from 'components/SVGInline/SVGInline';
import icons from 'style';
import { DropdownItemSimple, DropdownItemWithSvg, DropdownMenu } from 'components/DropdownMenu/DropdownMenu';
import { useAuth } from 'providers/useAuth/AuthContext';
import { useNavigation } from 'hooks/useNavigation';
import translate from 'utils/fnTranslate';
import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import { StaticPageRoutes } from 'types/RouteTypes';
import { DropdownItemWSeparator } from 'components/DropdownMenu/DropdownMenu.css';
import { buttonReset } from 'style/styled-components/cssButtonReset';
import { LoginButton } from './Header.css';

const HeaderAccount = styled.button`
    ${buttonReset}
    text-align: center;
    opacity: 1;
    transition: opacity 0.3s ease-in-out;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;

    .SVGInline {
        height: 32px;
        width: 32px;
    }

    &:hover {
        cursor: pointer;
        opacity: 0.6;
    }

    &:focus-visible {
        outline: var(--focus-outline);
    }
`;

const DropdownMenuSettingsComponent: React.FC = ({ ...rest }) => {
    const { isGuest, isLoggedIn, logUserIn, openLogOutAlert, userInfoDetails } = useAuth();
    const { navigate } = useNavigation();
    const [isOpen, setIsOpen] = useState(false);

    const onSettingsClicked = () => {
        navigate(StaticPageRoutes.SETTINGS);
    };

    const onLogInOutClicked = () => {
        if (!isGuest) {
            openLogOutAlert();
        } else {
            logUserIn();
        }
    };

    return (
        <>
            {isLoggedIn && !isGuest && (
                <DropdownMenu
                    {...rest}
                    triggerButton={
                        <HeaderAccount
                            type="button"
                            data-test-id={'header-account-dropdownbutton'}
                            aria-label={translate('ARIA_MENU_BUTTON')}
                            aria-expanded={isOpen}
                        >
                            <SVGInline svg={icons.userIcon} />
                        </HeaderAccount>
                    }
                    horizontalPosition={'right'}
                    verticalPosition={'bottom'}
                    visibilityChangeCallback={setIsOpen}
                >
                    <DropdownItemWithSvg svg={icons.avatarIcon}>{userInfoDetails?.email}</DropdownItemWithSvg>
                    {/* <DropdownItemWithSvg svg={icons.avatarIcon} onClick={onKidsClicked} hideOnDesktop={true}>
                        {translate('MODULE_MAIN_MENU_KIDS')}
                    </DropdownItemWithSvg> */}
                    <DropdownItemWSeparator />
                    <DropdownItemSimple onClick={onSettingsClicked} tabindex={isOpen ? 0 : -1}>
                        {translate('SETTINGS_SECTION_TITLE')}
                    </DropdownItemSimple>
                    <DropdownItemSimple onClick={onLogInOutClicked} tabindex={isOpen ? 0 : -1}>
                        {!isLoggedIn || isGuest ? translate('SETTINGS_LOGIN') : translate('SETTINGS_SIGNOUT')}
                    </DropdownItemSimple>
                </DropdownMenu>
            )}
            {(!isLoggedIn || isGuest) && (
                <LoginButton type="button" onClick={onLogInOutClicked}>
                    {translate('SCREEN_LOGIN_BUTTON')}
                </LoginButton>
            )}
        </>
    );
};

export const DropdownMenuSettings = styled(DropdownMenuSettingsComponent)`
    float: right;
`;
